import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { SelectItemComponent } from '@Components/ui/select-item/select-item.component';
import { AdfiGraphqlService } from '@services/adfi-graphql.service';
import { AdfiGrowlService } from '@services/adfi-growl.service';
import { AdfiService } from '@services/adfi-service';
import { LoadingService } from '@services/loading.service';
import { NavRouteService } from '@services/nav-routing-service';

@Component({
  selector: 'app-master-assets',
  templateUrl: './master-assets.component.html',
  styleUrls: ['./master-assets.component.scss']
})
export class MasterAssetsComponent implements OnInit {
  id: string;
  type: string;
  masterRegister: any;
  isLoading = false;
  listOrders: any[];
  orderId: number;
  orderWPId: number;
  canGenerateCertificate = false;
  certificateId: number;
  title = '';
  listTitle = '';

  constructor(
    private aRoute: ActivatedRoute,
    private graphqlService: AdfiGraphqlService,
    private adfiGrowlService: AdfiGrowlService,
    private adfiService: AdfiService,
    private sLoading: LoadingService,
    private navRouteService: NavRouteService,
    private dialog: MatDialog

  ) { }

  async ngOnInit(): Promise<void> {
    this.sLoading.show();
    this.id = this.aRoute.snapshot.paramMap.get('id');
    this.type = this.aRoute.snapshot.paramMap.get('type');
    if (Number(this.type) == 1) {
      await this.getMasterRegister();
      await this.getMasterAssets();
      this.title = 'Maestro Registro';
      this.listTitle = 'Listado de Órdenes de Pago';
    }else if(Number(this.type) == 2){
      await this.getMasterRegisterWP();
      await this.getMasterAssetsWP();
      this.title = 'Maestro Reserva';
      this.listTitle = 'Listado de Cuentas por Pagar';
    }
  }

  async getMasterRegister() {
    const filter = `id: ${this.id}`;
    const next = (data) => {
      this.masterRegister = data[0];
    };
    const error = (e) => {
      this.adfiGrowlService.errorMessage(e, 'Error al cargar los registros');
    };
    this.graphqlService.getEntity("masterRegisters", "concecutiveCDP consecutive object value", 1, filter, { next, error });
  }


  async getMasterAssets() {
    this.adfiService.get(`/api/get/master-assets/${this.id}`).subscribe((data: any) => {
      if (data) {
        this.listOrders = data[0].flat().map(order => ({
          id: order.N_ID,
          consecutive: order.PRORD_N_NUMORD,
          minipresu: order.V_MINIPRESU,
          nombre: order.V_NOMBRE,
          value: order.AVAILABLE
        }));
        this.canGenerateCertificate = this.listOrders.every(order => order.value == 0);
        if (data[1]) this.certificateId = data[1];
        this.sLoading.hide();
      }
    });
  }

  async getMasterRegisterWP() {
    const period = this.adfiService.periods.find(p => p.estado === "A");
    const filter = `id: ${this.id}, vigencia:${period.year - 1}`;
    const next = (data) => {
      this.masterRegister = data[0];
    };
    const error = (e) => {
      this.adfiGrowlService.errorMessage(e, 'Error al cargar los registros');
    };
    this.graphqlService.getEntity("masterRegisters", "concecutiveCDP consecutive object value", 1, filter, { next, error });
  }


  async getMasterAssetsWP() {
    this.adfiService.get(`/api/get/master-reserves/${this.id}`).subscribe((data: any) => {
      if (data) {
        this.listOrders = data[0].flat().map(order => ({
          id: order.N_ID,
          consecutive: order.PRORD_N_NUMORD,
          minipresu: order.V_MINIPRESU,
          nombre: order.V_NOMBRE,
          value: order.AVAILABLE
        }));
        this.canGenerateCertificate = this.listOrders.every(order => order.value == 0);
        if (data[1]) this.certificateId = data[1];
        this.sLoading.hide();
      }
    });
  }

  selectResponsible() {
    let dialogRef: MatDialogRef<any>;
    const data = {
      module: "MovimientoBienes",
      entityName: "PpeEmployee",
      enableAdd: false,
      defaultFilters: [
        {
          column: "cencos",
          value: "",
        },
        {
          column: "charge",
          value: true
        }
      ],
      customTitle: 'Seleccionar Delegado de Recibido'
    };

    dialogRef = this.dialog.open(SelectItemComponent, {
      data,
      width: "80%",
      maxHeight: "70vh",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.generateCertificate(result._id);
      }
    });
  }

  generateCertificate(ppeEmployee: number) {
    const nameClass = 'generateCertificate';
    const filters = Number(this.type) == 1 ? JSON.stringify({ orders: this.listOrders , ppeEmployee: ppeEmployee }) : JSON.stringify({ ordersWP: this.listOrders , ppeEmployee: ppeEmployee });
    const actions = '';
    const message = this.masterRegister.object;

    this.sLoading.show();

    const next = (val) => {
      this.certificateId = Number(val.message);
      this.adfiGrowlService.success('Correcto', 'Se ha generado el recibo de satisfacción.');
      this.sLoading.hide();
    };

    const error = (e) => {
      this.adfiGrowlService.errorMessage(e);
      this.sLoading.hide();
    };
    this.graphqlService.createEntity('Action', { nameClass, filters, actions, message }, 'message actions', { next, error });
  }

  openForm(orderId: number) {
    if (Number(this.type) == 1) {
        this.navRouteService.navigate('list/ZXNGODl4cUsrZHNxTlFBR1Rkc05lZz09/Wjg5ejh4S042UG9zUGljZA/' + orderId);
    }else if (Number(this.type) == 2) {
        this.navRouteService.navigate('list/ZXNGODl4cUsrZHNxTlFBR1Rkc05lZz09/ZHMxcDhRS042T1UvSXlNTlJOQStZSVNUYVlvdw/' + orderId);
    }
  }

  onButtonClick() {
      this.navRouteService.navigate('list/ZXNGODl4cUsrZHNxTlFBR1Rkc05lZz09/Wjl0NC9SK0M3OUE9');
  }
}
